import { Div, Span, Link } from "@tblabs/truffle";
import { Container } from "./Container";
import { Section } from "./Section";
import { H2 } from "./H2";
import { Svg } from "./Utils/Svg";
import { ContactForm } from "./ContactForm";


export class ContactBox extends Section
{
    constructor()
    {
        super("contact");
        this.Id("formularz-kontaktowy");

        this.Append(
            new Container().Append(
                new H2("Kontakt").Class("contact__title"),
                new Div("contact__grid").Append(
                    new Div("contact__info").Append(
                        new Div("contact__info-item").Append(
                            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone icon"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>`),
                            new Span("+48 507 293 714")
                        ),
                        new Div("contact__info-item").Append(
                            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin icon"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>`),
                            new Span("Warszawa, Polska")
                        ),
                        new Div("contact__info-item").Append(
                            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock icon"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`),
                            new Span("Pon-Pt: 10:00 - 17:00\nSob: 11:00 - 16:00")
                        ),
                      
                        new Div("contact__info-item").Append(
                            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plug-icon lucide-plug icon"><path d="M12 22v-5"/><path d="M9 8V2"/><path d="M15 8V2"/><path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"/></svg>`),
                            new Link("Inne formy kontaktu...", "#kontakt")
                        )
                    ),
                    // new ContactForm(),
                )
            )
        );
    }
}
